import { httpDelete, patch, post, put } from '../../utils/http';

export const addLabel = ({ accountId, branchId, title, startTime, endTime }) =>
  post(`/accounts/${accountId}/branches/${branchId}/labels`, { title, startTime, endTime });

export const updateLabels = ({ accountId, branchId, labels }) =>
  put(`/accounts/${accountId}/branches/${branchId}/labels`, { labels });

export const updateLabel = ({ accountId, branchId, labelId, title, startTime, endTime, isDeleted }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/labels/${labelId}`, { title, startTime, endTime, isDeleted });

export const deleteLabel = ({ accountId, branchId, labelId }) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/labels/${labelId}`);
